import React from "react";
import { Link } from "react-router-dom";

const Card = ({ imageUrl, captionLine, commentLine, buttonSpace }) => {
  return (
    <Link to="/registry">
      <div className="bg-blue-800 w-80 mx-auto md:w-full h-full px-4 py-10 rounded">
        <img className="w-20 mx-auto" src={imageUrl} alt="logo" />
        <div className="text-center">
          <div className="text-2xl font-bold text-white pt-2">
            {captionLine}
          </div>
          <div className="text-lg md:text-2xl font-semibold text-white py-4">
            {commentLine}
          </div>
          <Link to="/registry">
            <div className="text-lg mx-auto text-blue-900 bg-white rounded-3xl w-48 p-2">
              {buttonSpace}
            </div>
          </Link>
        </div>
      </div>
    </Link>
  );
};

export default Card;
